import React, { Component } from 'react';
import moment from 'moment';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';
import ceil from 'lodash/ceil';
import get from 'lodash/get';
import ReactTooltip from 'react-tooltip';
import {whiteLabelStyling} from '../../../utils/constants';

// import StoryGridItems from './StoryGridItems.jsx'
import If from '../../../components/Shared/If';
import { deepClone } from '../../../utils/copyObject';
import { calculateIndexRange } from '../../../utils/dashboardUtils';
import Paginations from '../../../components/Pagination/Pagination';
import { sortArray, sortDatesArray, sortNumbersArray } from '../../../components/Shared/ReusablesUtils';
import '../Analytics.css';
import NoDataFound from '../../../assets/no-kpidata-range.png';

class StoriesGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            adminSortOrder: 'asc',
            gridPagination: {
                currentPage: 1,
                recordCount: 10
            },
            storiesAnalytics: this.props.storiesAnalytics && size(this.props.storiesAnalytics.length) > 0 ? deepClone(this.props.storiesAnalytics) : [],
            searchKey: this.props.searchObject && !isEmpty(this.props.searchObject.storyTitle) ? get(this.props.searchObject, 'storyTitle', '') : ''
        }
    }

    componentWillReceiveProps(nextProps) {
        let { searchKey } = this.state;
        if (nextProps.searchObject.storyTitle !== searchKey) {
            this.setState({
                gridPagination: {
                    ...this.state.gridPagination,
                    currentPage: 1,
                    recordCount: 10
                }
            });
        }
        if (nextProps.storiesAnalytics) {
            this.setState({
                storiesAnalytics: nextProps.storiesAnalytics.map((eachChart) => {
                    return { ...eachChart, createdBy: this.getCreatedByName(eachChart.userId, eachChart.isAnonymous), storyStatus : this.getStoryStatus(eachChart) }
                })
            });
        }
    }

    getCreatedByName = (item, isAnonymous) => {
        if(isAnonymous) {
            return 'Anonymous';
        }
        else if (!isEmpty(item.firstName) && !isEmpty(item.lastName) && item["firstName"] !== undefined && item["lastName"] !== undefined) {
            return `${item.firstName} ${item.lastName}`
        }
        return 'NA';
    }

    getKeyValue = (object) => {
        const rowsArray = [];
        for (const [index, [key, value]] of Object.entries(Object.entries(object.metrics))) {
            rowsArray.push(<td>{object.metrics[key] instanceof Array && typeof object.metrics[key] !== undefined ? object.metrics[key].length : 0}</td>);
        }
        return rowsArray;
    };

    getStoryStatus = (item) => {

        return item.isDeleted ? `Archived ` : item.privacy === 'REMOVED' ? 'Removed from feed' : 'Active';
    }
    
    createMarkup = (input) => {
        // console.log(input)
        return { __html: `<div>${input}</div>` };
      }

    renderList = (list) => {
        if (list && list.length > 0) {
            // console.log(list)
            return list.map((item, index) => (
                <tr key={index}>
                    <td>
                    <span className="tooltip-text" data-tip={item.description.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "")} 
                    dangerouslySetInnerHTML={this.createMarkup(item.description)}></span>
                        <ReactTooltip />
                    </td>
                    <td>{moment(item.createdOn).format('MM/DD/YYYY')}</td>
                    <td>{this.getCreatedByName(item.userId, item.isAnonymous)}</td>
                    <td>{this.getStoryStatus(item)}</td>
                </tr>
            ));
        }
        return <tr><td>No record found</td></tr>;
    };

    getUserName = (item) => {
        if (!isEmpty(item.firstName) || !isEmpty(item.lastName)) {
            return `${item.firstName} ${item.lastName}`
        }
        return 'NA';
    }

    getColumnName = (columnName) => {
        const { storiesMetrics } = this.props;
        const columnDetails = storiesMetrics.filter((e) => e.id === columnName);
        return !isEmpty(columnDetails) ? columnDetails[0].name : '';
    }

    getMetricsDynamicHeader = (data) => {
        const headersArray = [];
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                headersArray.push(<th scope="col" className='bottom-border-color' style={{ borderTop: 'none', width: '400px' }}><span className="table-sort-title">{this.getColumnName(key)}</span><span onClick={this.sortDynamicMetrics} sortkey={key} className="table-sort-icon pull-right fa fa-sort"></span></th>);
            }
        }
        return headersArray;
    }

    sortStoryName = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.storiesAnalytics.map((eachChart) => {
            return { ...eachChart, createdBy: this.getCreatedByName(eachChart.userId, eachChart.isAnonymous),  }
        });

        this.setState({ adminSortOrder }, () => {
            let updatedList = sortArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                storiesAnalytics: updatedList
            });
        });
    }

    sortStoryByStatus = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.storiesAnalytics.map((eachChart) => {
            return { ...eachChart, createdBy: this.getCreatedByName(eachChart.userId, eachChart.isAnonymous), storyStatus : this.getStoryStatus(eachChart) }
        });

        this.setState({ adminSortOrder }, () => {
            let updatedList = sortArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                storiesAnalytics: updatedList
            });
        });
    }

    sortDates = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.storiesAnalytics.map((eachChart) => {
            return { ...eachChart, createdBy: this.getCreatedByName(eachChart.userId, eachChart.isAnonymous) }
        });


        this.setState({ adminSortOrder }, () => {
            let updatedList = sortDatesArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                storiesAnalytics: updatedList
            });
        });
    }

    sortDynamicMetrics = (event) => {
        const key = event.target.getAttribute('sortkey');
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.storiesAnalytics.map((eachChart) => {
            return { ...eachChart, createdBy: this.getCreatedByName(eachChart.userId, eachChart.isAnonymous) }
        });


        this.setState({ adminSortOrder }, () => {
            let updatedList = sortNumbersArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                chartAnalytics: updatedList
            });
        });
    }

    handlePageNavigation = (nextOrPrevious) => {
        if (nextOrPrevious === 'previous' || nextOrPrevious === 'next') {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: nextOrPrevious === 'previous' ? parseInt(this.state.gridPagination.currentPage - 1) : parseInt(this.state.gridPagination.currentPage + 1)
                    }
                }
            );
        } else {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: parseInt(nextOrPrevious)
                    }
                }
            );
        }

    }

    handleRecordCountChange = (event) => {
        let { value } = event.target;
        let { gridPagination: { recordCount } } = this.state;
        this.setState({ gridPagination: { ...this.state.gridPagination, recordCount: parseInt(value), totalPage: ceil(size(this.state.userAnalytics) / recordCount) } });
    }

    generatePageNumbers = (userAnalytics) => {
        let { currentPage, recordCount } = this.state.gridPagination;
        let pageNumbers = [];

        if (recordCount > size(userAnalytics)) {
            pageNumbers = [];
        } else {
            for (let i = 1; i <= ceil(size(userAnalytics) / recordCount); i++) {
                pageNumbers.push(<li key={i} className="page-item"><span className={currentPage === i ? 'page-link currentpage-active' : 'page-link'} onClick={() => this.handlePageNavigation(i)}>{i}</span></li>)
            }
        }
        // Slice only 1 to 10 Page
        let pageNumbersInitial = pageNumbers.slice(0, 10);
        return pageNumbersInitial;
    }

    render() {

        let { storiesAnalytics } = this.state;
        let { gridPagination: { currentPage, recordCount } } = this.state;
        let test = calculateIndexRange(currentPage, recordCount);
        const slicedRecords = storiesAnalytics && storiesAnalytics.slice(test.begin, test.end);
        let totalPageNumber = ceil(size(storiesAnalytics) / recordCount);
        let nodatafound = null;

        if (storiesAnalytics && storiesAnalytics.length === 0) {
          nodatafound = (<div className="text-center no-data-available-desc">
            <p style={{ marginBottom: '0px' }}>Looks like there's no data available for the parameters you selected.</p>
            <p> Try adjusting your filters, dates.</p>
            <img src={NoDataFound} className="no-kpi-date-range" />
          </div>)
        }

        return (
            <div>
                {storiesAnalytics.length > 0 && (
                <div>
                    {/* scrollbar-color */}
                <div className="row p-0 m-0 mt-3 mb-2 table-responsive-sm table-ellipsis" >
                    <table className="toolkit-list table text-primary-color tool-list-font" style={{ borderTop: '0px' }}>
                        <thead>
                            <tr className="col-sm-4 mb-3">
                                <th scope="col" className='bottom-border-color'><span className="table-sort-title">Story Title</span><span onClick={() => this.sortStoryName('description')} className="table-sort-icon fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color'><span className="table-sort-title">Date Created</span><span onClick={() => this.sortDates('createdOn')} className="table-sort-icon fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color'><span className="table-sort-title">Created by</span><span onClick={() => this.sortStoryName('createdBy')} className="table-sort-icon fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color'><span className="table-sort-title">Story Status</span><span onClick={() => this.sortStoryByStatus('storyStatus')} className="table-sort-icon fa fa-sort"></span></th>                                  
                            </tr>
                        </thead>
                        <tbody>{this.renderList(slicedRecords)}</tbody>
                    </table>
                </div>
                <If condition={size(storiesAnalytics) > 0}>
                    <Paginations
                        currentPage={currentPage}
                        totalPageNumber={totalPageNumber}
                        handlePageNavigation={this.handlePageNavigation}
                        Analytics={storiesAnalytics}
                        generatePageNumbers={this.generatePageNumbers}
                        handleRecordCountChange={this.handleRecordCountChange}
                        recordCount={recordCount}
                        totalRecords={size(storiesAnalytics)}
                    />
                </If>
                </div>
                )}
                {nodatafound}
            </div>
        )
    }
}

export default StoriesGrid;